import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { SeperatorComponent } from '../../eqform';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'delete-confirmation-dialog',
    templateUrl: './delete-confirmation-dialog.component.html',
    styleUrl: './delete-confirmation-dialog.component.scss',
    imports: [MatButtonModule, MatDialogModule, MatIconModule, SeperatorComponent, CommonModule],
    standalone: true
})
export class DeleteConfirmationDialogComponent {
    header!: string;
    acceptLabel!: string;
    rejectLabel!: string;
    warn: any;
    
    ngOnInit(): void {
        this.header = this.data?.header;
        this.acceptLabel = this.data?.acceptLabel;
        this.rejectLabel = this.data?.rejectLabel;   
        this.warn = this.data?.warn     
    }
    constructor(
        public dialogRef: MatDialogRef<DeleteConfirmationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }
}
